export function parseAmount(value) {
    const str = String(value ?? '').replace(/[^0-9.]/g, '');
    return parseFloat(str) || 0;
}
